export const RequirementsRules = [
  {
    name: 'LOWERCASE',
    regex: /[a-z]/,
  },
  {
    name: 'UPPERCASE',
    regex: /[A-Z]/,
  },
  {
    name: 'MINIMUM_LENGTH',
    regex: /^.{12,}$/,
  },
  {
    name: 'DIGIT',
    regex: /\d/,
  },
  {
    name: 'SPECIAL_CHARACTER',
    regex: /[/./,/?/&/!/:/;/#/(/)/=/{/}]+/,
  },
];
